// ChatMessage.jsx
import React from 'react';
import MensagemImagem from './MensagemImagem';
import MensagemSticker from './MensagemSticker';
import MensagemAudio from './MensagemAudio';
import MensagemDocumento from './MensagemDocumento';
import ChatMessageDataHora from './ChatMessageDataHora';
import MensagemRespondidaPreview from './MensagemRespondidaPreview';
import MensagemTemplate from './MensagemTemplate';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReply, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { renderizarMensagemWhatsApp } from '../../../Utils/renderizarMensagemWhatsApp'; // ajuste o caminho certo


const ChatMessage = ({
    mensagem,
    mensagemRespondida,
    onResponderMensagem,
    onScrollToMensagem,
    highlighted,
    refCallback
}) => {
    const tipo = mensagem.logConversasWhatsAppTipo?.toLowerCase();
    const isSent = mensagem.logConversasWhatsAppDirecao === 'sent';
    const isFailed = mensagem.logConversasWhatsAppStatus?.toLowerCase() === 'failed';
    const className = `chat-message ${isSent ? 'sent' : 'received'} ${highlighted ? 'highlighted' : ''}`;

    const conteudoMidia = () => {
        if (!mensagem.logConversasWhatsAppMediaId) return null;

        switch (tipo) {
            case 'image':
                return <MensagemImagem mensagem={mensagem} />;
            case 'sticker':
                return <MensagemSticker mensagem={mensagem} />;
            case 'audio':
                return <MensagemAudio mensagem={mensagem} />;
            case 'document':
                return <MensagemDocumento mensagem={mensagem} />;
            default:
                return null;
        }
    };

    const handleResponderClick = () => {
        if (onResponderMensagem) {
            onResponderMensagem(mensagem);
        }
    };

    const handleMensagemRespondidaClick = () => {
        if (mensagemRespondida && onScrollToMensagem) {
            onScrollToMensagem(mensagemRespondida);
        }
    };

    return (
        <div className={className} ref={refCallback}>
            {mensagemRespondida && (
                <div
                    className="mensagem-respondida-preview-wrapper"
                    onClick={handleMensagemRespondidaClick}
                >
                    <MensagemRespondidaPreview mensagem={mensagemRespondida} />
                </div>
            )}

            {tipo === 'template' ? (
                <MensagemTemplate mensagem={mensagem} />
            ) : mensagem.logConversasWhatsAppMediaId ? (
                conteudoMidia()
            ) : (
                <div className="chat-message-text">
                    {renderizarMensagemWhatsApp(mensagem.logConversasWhatsAppMensagem)}
                </div>
            )}

            <div className="chat-message-footer">
                <ChatMessageDataHora dataHora={mensagem.logConversasWhatsAppDataExibicao} />

                <FontAwesomeIcon
                    icon={faReply}
                    onClick={handleResponderClick}
                    className="chat-reply-icon"
                    role="button"
                    title="Responder"
                />
            </div>
            {/* FAIXA DE ERRO */}
            {isSent && isFailed && (
                <div className="chat-message-failed-banner">
                    <FontAwesomeIcon icon={faExclamationCircle} /> Falha no envio da mensagem
                </div>
            )}
        </div>
    );
};

export default ChatMessage;
